/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * FEST — die Art bringt ihre Hoehe mit: 72 px bei den mehrzeiligen,
 * 34 px bei den einzeiligen. So sieht das Band aus wie in der Vorlage,
 * unabhaengig davon, wie gross die Rasterzelle gezogen wurde.
 * 
 * ANGEPASST (Vorgabe) — der Baustein fuellt seine Zelle, wie bisher.
 * Bestehende Datenbanken aendern sich damit um kein Pixel.
 * @export
 */
export const DatabaseBannerHoehe = {
    Fest: 'FEST',
    Angepasst: 'ANGEPASST'
} as const;
export type DatabaseBannerHoehe = typeof DatabaseBannerHoehe[keyof typeof DatabaseBannerHoehe];


export function DatabaseBannerHoeheFromJSON(json: any): DatabaseBannerHoehe {
    return DatabaseBannerHoeheFromJSONTyped(json, false);
}

export function DatabaseBannerHoeheFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseBannerHoehe {
    return json as DatabaseBannerHoehe;
}

export function DatabaseBannerHoeheToJSON(value?: DatabaseBannerHoehe | null): any {
    return value as any;
}

